import { render, staticRenderFns } from "./printInvoiceFranchiseeToBB.vue?vue&type=template&id=4ad9dbc9&scoped=true"
import script from "./printInvoiceFranchiseeToBB.vue?vue&type=script&lang=en"
export * from "./printInvoiceFranchiseeToBB.vue?vue&type=script&lang=en"
import style0 from "./printInvoiceFranchiseeToBB.vue?vue&type=style&index=0&id=4ad9dbc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad9dbc9",
  null
  
)

export default component.exports